(ns manatee.ajax
  (:require #?(:clj [clj-time.format :as tf]
               :cljs [cljs-time.format :as tf])
            #?(:clj [clojure.edn :as edn]
               :cljs [cljs.reader :as edn])
            #?(:cljs [ajax.core :refer [default-interceptors to-interceptor]])
            #?(:cljs [bedrock-ui.http.interceptors :as bedrock-interceptors])
            #?(:cljs [re-frame.core :as rf])
            [ajax.interceptors :refer [map->ResponseFormat]]
            [ajax.protocols :refer [-body]]
            [bedrock-ui.sentry.handlers :as sentry-handlers]))

#?(:cljs
   (def invalid-auth-token-interceptor
     (to-interceptor {:name "Invalid auth token interceptor"
                      :response (fn [response]
                                  (when (= (ajax.protocols/-status response) 401)
                                    (rf/dispatch [:manatee.auth.handlers/sign-out]))
                                  response)})))
#?(:cljs
   (def sentry-interceptor
     (bedrock-interceptors/make-error-logging-interceptor
      #(rf/dispatch [::sentry-handlers/capture-message %])))
   :clj
   (def pacify-linter ::sentry-handlers/capture-message))

#?(:cljs
   (defn init-cljs-ajax!
     [_config]
     (swap! default-interceptors
            #(->> %
                  (cons sentry-interceptor)
                  (cons invalid-auth-token-interceptor)))))

(defn edn-read [xhrio]
  (let [bod (-> xhrio -body)
        res (edn/read-string {:readers {'clj-time/date-time tf/parse}} bod)]
    res))

(defn edn-response-format
  [] (map->ResponseFormat {:read edn-read
                           :description "EDN"
                           :content-type ["application/edn"]}))

#?(:cljs
   (defn edn-blob
     [x]
     (-> x
         (pr-str)
         (vector)
         (js/Blob. #js{"type" "application/edn"}))))
